// leaving commented lines for future style extensions

export function buildHTMLStyleStringFromNodeStyle(nodeStyle: CSSStyleDeclaration): string {
    const backgroundColor = nodeStyle.backgroundColor;
    const color = nodeStyle.color;
    // const fontFamily = nodeStyle.fontFamily;
    // const fontWeight = nodeStyle.fontWeight;
    // const fontSize = nodeStyle.fontSize;
    // const textDecoration = nodeStyle.textDecoration;

    return [
        backgroundColor ? `background-color: ${backgroundColor}` : null,
        color ? `color: ${color}` : null
        // fontFamily ? `font-family: ${fontFamily}` : null,
        // fontWeight ? `font-weight: ${fontWeight}` : null,
        // fontSize ? `font-size: ${fontSize}` : null,
        // textDecoration ? `text-decoration: ${textDecoration}` : null
    ]
        .filter(Boolean)
        .join('; ');
}
